(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5477],{

/***/ 85477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hero014": function() { return /* binding */ Hero014; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14258);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var _Hero014_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73086);
/* harmony import */ var _Hero014_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Hero014_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Hero014 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var text = (ref1 = payload === null || payload === void 0 ? void 0 : payload.text) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var lead = (ref2 = payload === null || payload === void 0 ? void 0 : payload.lead) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var image = (ref3 = payload === null || payload === void 0 ? void 0 : payload.image) !== null && ref3 !== void 0 ? ref3 : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Hero014_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Hero014_module_scss__WEBPACK_IMPORTED_MODULE_3___default().block),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .ImageLite */ .NH, {
                        image: image,
                        className: (_Hero014_module_scss__WEBPACK_IMPORTED_MODULE_3___default().image)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Hero014_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading2 */ .XJ, {
                                className: (_Hero014_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__/* .RichText */ .H, {
                                value: lead,
                                className: (_Hero014_module_scss__WEBPACK_IMPORTED_MODULE_3___default().preview)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__/* .RichText */ .H, {
                                color: "dark",
                                value: text,
                                className: (_Hero014_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Hero014);


/***/ }),

/***/ 73086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero014_wrapper__rJEK3","block":"Hero014_block__mhT50","content":"Hero014_content__URA3B","title":"Hero014_title__hl9so","image":"Hero014_image__nELUl","preview":"Hero014_preview__NVu_V","description":"Hero014_description__3Ewfe"};

/***/ })

}]);